import { Space, SpaceResponse } from "../coworkerApiCalls/Space/SpacesTypes";
import { quotaResponsesToQuotas } from "./QuotaMapper";

const spaceResponseToSpace = (space: SpaceResponse): Space => {
  return {
    id: space.id,
    name: space.name,
    city: space.city,
    address: space.address,
    postCode: space.postCode,
    quotas: quotaResponsesToQuotas(space.quotas),
  };
};

const spaceResponsesToSpaces = (spaces: SpaceResponse[]): Space[] => {
  return spaces.map((space: SpaceResponse): Space => spaceResponseToSpace(space));
};

export { spaceResponseToSpace, spaceResponsesToSpaces };